import React from 'react';
import intersection from 'lodash.intersection';
import unionBy from 'lodash.unionby';
// import { mdMosRuLink } from './endpoints';

/**
 * поиск пересечения массивов
 * @param firstArray
 * @param secondArray
 * @returns {boolean}
 */
const isIntersection = (firstArray, secondArray) => {
  const intersectionArrays = intersection(firstArray, secondArray);
  return intersectionArrays.length > 0;
};

/**
 * поиск полного пересечения массивов
 * ищем полное вхождение filtersArray в secondArray
 * @param filtersArray - массив фильтров
 * @param secondArray
 * @returns {boolean}
 */
const isFullIntersection = (filtersArray, secondArray) => {
  const intersectionArrays = intersection(filtersArray, secondArray);
  return intersectionArrays.length === filtersArray.length;
};

const compareByName = (firstItem, secondItem) => {
  if (firstItem.name > secondItem.name) {
    return 1;
  }
  if (firstItem.name < secondItem.name) {
    return -1;
  }
  return 0;
};

export const getPresentationalFilters = (rawFilters, enabledFilters) => {
  const filtersWithEnabledField = rawFilters.map((item) => {
    if (item.ids) {
      return {
        ...item,
        enabled: isIntersection([item.ids, item.id], enabledFilters),
      };
    }

    return {
      ...item,
      enabled: enabledFilters.includes(item.id),
    };
  });

  const enabled = filtersWithEnabledField.filter((item) => item.enabled);
  const disabled = filtersWithEnabledField.filter((item) => !item.enabled);

  return [...enabled, ...disabled].sort(compareByName);
};

export const getPresentationalFiltersWithSortEnabledField = (
  rawFilters,
  enabledFilters
) => {
  const filtersWithEnabledField = rawFilters.map((item) => {
    if (item.ids) {
      return {
        ...item,
        enabled: isIntersection([item.ids, item.id], enabledFilters),
      };
    }

    return {
      ...item,
      enabled: enabledFilters.includes(item.id),
    };
  });

  const enabled = filtersWithEnabledField.filter((item) => item.enabled);
  const disabled = filtersWithEnabledField.filter((item) => !item.enabled);

  return [...enabled.sort(compareByName), ...disabled.sort(compareByName)];
};

export const changeFilters = (fieldName, state, changedIds, replace) => {
  const ids = Array.isArray(changedIds) ? changedIds : [changedIds];
  const currentFieldState = state.filters[fieldName];

  if (replace) return ids;

  return ids.reduce((acc, id) => {
    const found = acc.indexOf(id) !== -1;

    if (found) {
      return acc.filter((item) => item !== id);
    }

    return [...acc, id];
  }, currentFieldState);
};

const getFilteredOfficesOnServices = (offices, filters) => {
  const filteredOnServices = offices.filter((office) => {
    const servicesInOffice = unionBy(
      office.servicesInOffice,
      office.bookableServicesIds,
      office.services
    );
    return isFullIntersection(filters.services, servicesInOffice);
  });
  if (filteredOnServices.length > 0) {
    return filteredOnServices;
  }
  return [];
};

const getFilteredOfficesOnAreas = (offices, filters) => {
  if (filters.areas.length === 0) {
    return [];
  }
  const filteredOffices = offices.filter((office) =>
    isIntersection(filters.areas, office.okato)
  );
  if (filteredOffices.length > 0) {
    return filteredOffices;
  }
  return [];
};

const getFilteredOfficesOnMetro = (offices, filters) => {
  if (filters.undergrounds.length === 0) {
    return [];
  }
  const filtersUndergroundsNormalize = filters.undergrounds.map((item) =>
    parseInt(item, 10)
  );
  const filteredOffices = offices.filter((office) =>
    isIntersection(
      filtersUndergroundsNormalize,
      office.address.metroLocations.map((location) =>
        parseInt(location.metroStationId, 10)
      )
    )
  );
  if (filteredOffices.length > 0) {
    return filteredOffices;
  }
  return [];
};

const filteredOfficesOnAreasAndMetro = (
  filteredOnAreas,
  filteredOnMetro,
  filteredOnServices,
  filters
) => {
  const filteredOnAreasIsBlank = filters.areas.length === 0;
  const filteredOnAreasIsPresent = filters.areas.length !== 0;
  const filteredOnMetroIsBlank = filters.undergrounds.length === 0;
  const filteredOnMetroIsPresent = filters.undergrounds.length !== 0;

  if (filteredOnAreasIsBlank && filteredOnMetroIsBlank) {
    return filteredOnServices;
  }
  if (filteredOnAreasIsBlank && filteredOnMetroIsPresent) {
    return filteredOnMetro;
  }
  if (filteredOnAreasIsPresent && filteredOnMetroIsBlank) {
    return filteredOnAreas;
  }
  if (filteredOnAreasIsPresent && filteredOnMetroIsPresent) {
    return unionBy(filteredOnAreas, filteredOnMetro, 'id');
  }
  return filteredOnServices;
};

// typograf-enable

const prepareFlagman = (office) => {
  switch (office.id) {
    // TODO: реализовать вместо этого хард-кода нормальный признак с бэка на тип МФЦ
    case 499:
    case 506:
    case 524:
    case 540:
    case 542:
    case 544:
      return {
        type: 'flagman',
        description: [
          'Флагманские офисы расположены в крупных торговых центрах, рядом со станциями метро. Здесь жители могут получить свыше 280 государственных услуг. Во флагманских офисах доступны уникальные услуги регистрации ТС, оформления водительского удостоверения в день обращения, услуги для бизнеса, а также целый ряд услуг Фонда социального страхования. Помимо получения государственных и муниципальных услуг жители города и гости столицы могут воспользоваться дополнительными сервисами – проверить свое здоровье, сделать фото, забронировать путевку, оформить нотариальные документы и обратиться за услугами банка, а также пообщаться в кафе с друзьями. На территории обустроен детский уголок, комната матери и ребенка, мобильные переговорные и конференц-зал, где каждую неделю проходят интересные, образовательные лекции и семинары для посетителей всех возрастов.',
          <div>
            Флагманские офисы «Мои Документы» открыты с 10:00 до 22:00 без
            перерывов и выходных.
          </div>,
        ],
      };
    case 512:
      return {
        type: 'palace',
        description: [
          'В центрах «Мои Документы» предоставляется свыше 270 государственных услуг. Посетители Дворца госуслуг могут также воспользоваться особенной и беспрецедентной услугой – подать документы для осуществления государственного кадастрового учета и государственной регистрации прав на объекты недвижимости, расположенные в любом субъекте Российской Федерации. Дворец госуслуг «Мои Документы» на ВНДХ открыт для посетителей ежедневно с 10:00 до 22:00.',
        ],
      };
    default:
      return {
        name: office.name,
        type: 'default',
        description: [
          'Центры госуслуг – это комфортные офисы в каждом районе Москвы, где ежедневно быстро и удобно можно получить государственные услуги. 98 % услуг предоставляются без привязки к месту жительства. Районные центры госуслуг работают по удобному графику с 08:00 до 20:00 без перерывов и выходных.',
        ],
      };
  }
};
// typograf-disable

// const isSpecificallyClosed = office => {
//   if (
//     office.id === '184' ||
//     office.id === 184 ||
//     office.id === '224' ||
//     office.id === 224 ||
//     office.id === '316' ||
//     office.id === 316
//   ) {
//     return 'CLOSE';
//   }
//
//   return false;
// };
//
// const getSpecificallyReplacement = (office, offices) => {
//   if (office.id === '184' || office.id === 184) {
//     offices.find(({ id }) => id === '77' || id === 77);
//   }
//
//   if (office.id === '224' || office.id === 224) {
//     offices.find(({ id }) => id === '313' || id === 313);
//   }
//
//   return null;
// };

export const convertIds = (entities) =>
  entities.map((entity) => ({
    ...entity,
    id: `${entity.id}`,
  }));

export const prepareOffices = (offices) =>
  offices
    .filter(
      (office) =>
        office.address && office.address.latitude && office.address.longitude
    )
    .map((office) => ({
      ...office,
      bookableServicesIds: office.bookableServicesIds.map(Number),
      services: office.services,
      servicesInOffice: office.servicesInOffice.map(Number),
      auxiliaryServicesIds: office.auxiliaryServicesIds.map(Number),
    }))
    .filter(({ id }) => id !== 510)
    .map((office) => {
      const replacementOffice =
        office?.officeServiceSchedule?.replacementOffice;

      return {
        ...office,
        ...prepareFlagman(office),
        replacementOffice: replacementOffice
          ? offices.find(({ id }) => id === +replacementOffice)
          : '',
        status: office?.officeServiceSchedule?.closedOffice
          ? 'CLOSE'
          : 'ACTIVE',
      };
    });

export const filter = (offices, filters) => {
  /**
   * логика фильтрации
   * [(OR{Районы}) OR (OR{Метро})] AND [AND{Услуги}]
   * filters
   * areas: [45293554] район, в json офисов поле okato
   * services: [732] услуги оказываемые центром
   * undergrounds: [] метро
   */

  const filteredOfficesOnServices = getFilteredOfficesOnServices(
    offices,
    filters
  );

  const filteredOfficesOnAreas = getFilteredOfficesOnAreas(
    filteredOfficesOnServices,
    filters
  );

  const filteredOfficesOnMetro = getFilteredOfficesOnMetro(
    filteredOfficesOnServices,
    filters
  );

  return filteredOfficesOnAreasAndMetro(
    filteredOfficesOnAreas,
    filteredOfficesOnMetro,
    filteredOfficesOnServices,
    filters
  );
};
